<template>
  <div class="select-interval">
    <el-popover
      v-model="popoverVisible"
      ref="popover"
      placement="bottom"
      width="300"
      trigger="click">
      <el-tree
        node-key="id"
        ref="tree"
        :data="data"
        :default-expand-all="true"
        :default-checked-keys="defaultCheckedKeys"
        show-checkbox
        @check-change="handleCheckedChange">
      </el-tree>
    </el-popover>
    <el-input placeholder="请选择时间段" v-model="inputValue" readonly>
      <el-button slot="append" icon="el-icon-arrow-down" v-popover:popover></el-button>
    </el-input>
  </div>
</template>

<script>
  const selectIntervals = {
    0: [
      '00:00-00:30', '00:30-01:00', '01:00-01:30', '01:30-02:00', '02:00-02:30', '02:30-03:00', '03:00-03:30', '03:30-04:00',
      '04:00-04:30', '04:30-05:00', '05:00-05:30', '05:30-06:00', '06:00-06:30', '06:30-07:00', '07:00-07:30', '07:30-08:00',
      '08:00-08:30', '08:30-09:00', '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00',
      '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00', '15:00-15:30', '15:30-16:00',
      '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00', '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00',
      '20:00-20:30', '20:30-21:00', '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00', '23:00-23:30', '23:30-24:00'
    ],
    1: [
      '00:00-01:00', '01:00-02:00', '02:00-03:00', '03:00-04:00', '04:00-05:00', '05:00-06:00', '06:00-07:00', '07:00-08:00',
      '08:00-09:00', '09:00-10:00', '10:00-11:00', '11:00-12:00', '12:00-13:00', '13:00-14:00', '14:00-15:00', '15:00-16:00',
      '16:00-17:00', '17:00-18:00', '18:00-19:00', '19:00-20:00', '20:00-21:00', '21:00-22:00', '22:00-23:00', '23:00-00:00',
    ],
    2: [
      '00:00-02:00', '02:00-04:00', '04:00-06:00', '06:00-08:00', '08:00-10:00', '10:00-12:00',
      '12:00-14:00', '14:00-16:00', '16:00-18:00', '18:00-20:00', '20:00-22:00', '22:00-24:00'
    ],
    3: [
      '00:00-04:00', '04:00-08:00', '08:00-12:00', '12:00-16:00', '16:00-20:00', '20:00-24:00'
    ]
  };

  export default {
    props: ['defaultValue'],
    inheritAttrs: false,
    data () {
      return {
        popoverVisible: false,
        inputValue: `已选择 ${selectIntervals[this.defaultValue].length} 个时段`,
        data: [],
        defaultCheckedKeys: []
      };
    },
    created () {
      const defaultCheckedKeys = [];
      this.data = [{
        id: 'all',
        label: '全部',
        children: selectIntervals[this.defaultValue].map((item, index) => {
          defaultCheckedKeys.push(index);
          return {
            id: index,
            label: item
          };
        })
      }];
      this.defaultCheckedKeys = defaultCheckedKeys;
    },
    watch: {
      defaultValue (val) {
        const defaultCheckedKeys = [];
        this.data = [{
          id: 'all',
          label: '全部',
          children: selectIntervals[val].map((item, index) => {
            defaultCheckedKeys.push(index);
            return {
              id: index,
              label: item
            };
          })
        }];
        this.defaultCheckedKeys = defaultCheckedKeys;
        this.inputValue = `已选择 ${selectIntervals[val].length} 个时段`;
      }
    },
    methods: {
      getInstance () {
        return this.$refs.tree;
      },
      handleCheckedChange () {
        let checkedNodes = this.$refs.tree.getCheckedNodes(true);
        switch (checkedNodes) {
          case 0:
            this.inputValue = '';
            break;
          case 1:
            this.inputValue = checkedNodes[0].label;
            break;
          default:
            this.inputValue = `已选择 ${checkedNodes.length} 个时段`;
        }
      }
    }
  };
</script>

<style lang="less">
  .select-interval {
    input {
      cursor: pointer;
    }
    .el-input-group__append {
      padding: 0;
      .el-button {
        min-width: 75px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// SelectInterval.vue?79e27d83